import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { resolvePath } from "@utils/resolvePath";
import { CommonProps } from "@utils/interface";
import {
  Card,
  Content,
  Heading,
  Description,
  LearnMore,
  Image,
} from "./styles";

export interface SdCardPromoCardProps extends CommonProps {
  heading?: string;
  description?: string;
  cta_label?: string;
  imageSrc?: string;
  imageAlt?: string;
  imageWidth?: number;
  imageHeight?: number;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
  };
};

const SdCardPromoCard = (props: SdCardPromoCardProps) => {
  const {
    is_visible,
    heading,
    description,
    cta_label = "Learn More",
    imageSrc = "/images/dashcam/sdcard.png",
    imageAlt = "",
    imageWidth = 64,
    imageHeight = 63.015,
    actions,
  } = props;

  if (!is_visible) return null;

  const handleLearnMoreClick = () => {
    actions?.on_click?.forEach((eachFunc: any) => {
      if (eachFunc && typeof eachFunc.funCall === "function") {
        eachFunc.funCall(eachFunc.args || {});
      }
    });
  };

  return (
    <Card>
      <Content>
        {heading && <Heading>{heading}</Heading>}
        {description && <Description>{description}</Description>}
        <LearnMore onClick={handleLearnMoreClick}>{cta_label}</LearnMore>
      </Content>
      {imageSrc && (
        <Image
          src={resolvePath("/images/dashcam/sdcard.png")}
          alt={imageAlt || heading || "SD card"}
          width={imageWidth}
          height={imageHeight}
        />
      )}
    </Card>
  );
};

export default connect(mapStateToProps)(SdCardPromoCard);
